import '../../../../../theme/reorder.css';
import { IonButton, IonButtons, IonCard, IonCardContent, IonContent, IonFab, IonFabButton, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonPage, IonRadio, IonRadioGroup, IonReorder, IonReorderGroup, IonTitle, IonToast, IonToggle, IonToolbar, isPlatform, ItemReorderEventDetail, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { add, arrowBack, cashOutline, eyeOff, eyeOutline, informationCircleOutline, pencil, reorderTwo, ticketOutline, trash } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { empresaConfiguracoesAlterar, ordernarItemConfiguracoesCupomEmpresa, removerConfiguracoesCupomEmpresa, requestService } from '../../../../../Utils/Services';
import "./ConfiguracoesCupom.css";

type Props = {
  onDismiss: () => void;
};

const ConfiguracoesCupom: React.FC<Props> = (props: Props) => {

  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaConfiguracoesCupom, setListaConfiguracoesCupom] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [index, setIndex] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");


  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const podeOrdenar = acessos?.configuracoes === 'edicao';
  const isWeb = isPlatform('desktop');
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);


  const inputRef = useRef<any>(null);
  const [tipo, setConfiguracoesCupom] = useState('');

  const [idConfiguracaoEndereco, setIdConfiguracaoEndereco] = useState<any>();
  const [nome, setNome] = useState<any>();
  const [valor, setValor] = useState<any>();
  const [valorMinimo, setValorMinimo] = useState<any>();
  const [visivel, setVisivel] = useState<boolean>(true);
  // Compatibilidade: cupons antigos sem o campo são interpretados como "fixo".
  const [tipoDesconto, setTipoDesconto] = useState<"fixo" | "percentual">("fixo");
  // Base do desconto percentual. Compatibilidade: ausente ⇒ "produtos".
  const [baseDesconto, setBaseDesconto] = useState<"produtos" | "total">("produtos");

  const [mostartAlerta] = useIonAlert();

  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    setListaConfiguracoesCupom(dadosEmpresa.configuracoesCupom || []);
  });

  function deletarConfiguracoesCupom(indice: any) {

    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const delConfiguracoesCupom = async () => {
      setShowLoading(true);
      try {
        const resp = await fetch(removerConfiguracoesCupomEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
          {
            method: removerConfiguracoesCupomEmpresa.method,
            headers: [
              ["token", token]
            ],
            body: JSON.stringify({ 'index': indice }),
            credentials: 'include'
          });
        const response = await resp.json();

        if (response) {
          setListaConfiguracoesCupom(response.message.Attributes.configuracoesCupom || []);
          dadosEmpresa.configuracoesCupom = response.message.Attributes.configuracoesCupom;
          setDadosEmpresa(dadosEmpresa);


          console.log("retorno", response);
          setTextToast("Configuração removida com sucesso.");
          setShowToast(true);
        }
        // carregarConta();
      } catch (err) {
        console.log(err);
        setTextToast("Ocorreu um erro ao remover.");
        setShowToast(true);
      } finally {
        setShowLoading(false);
      }
    }

    delConfiguracoesCupom();

  }

  function handleReorder(event: CustomEvent<ItemReorderEventDetail>) {
    if (!podeOrdenar || showLoading || event.detail.from === event.detail.to) {
      event.detail.complete(false);
      return;
    }

    // Before complete is called with the items they will remain in the
    // order before the drag
    //console.log('Before complete', listaItemCatalogoProdutos);

    // Finish the reorder and position the item in the DOM based on
    // where the gesture ended. Update the items variable to the
    // new order of items
    setListaConfiguracoesCupom(event.detail.complete(listaConfiguracoesCupom));

    // After complete is called the items will be in the new order
    //console.log('After complete', listaItemCatalogoProdutos);


    var token: string = "";
    var tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") { token = tkn; }

    const ordItemConfiguracoesCupom = async () => {
      const resp = await fetch(ordernarItemConfiguracoesCupomEmpresa.url.replace("{id}", loja.replace(/#/g, "%23")),
        {
          method: ordernarItemConfiguracoesCupomEmpresa.method,
          headers: [
            ["token", token]
          ],
          body: JSON.stringify({ 'configuracoesCupom': listaConfiguracoesCupom }),
          credentials: 'include'
        });
      const retorno = await resp.json();
      console.log("retorno ordenar", retorno);

      if (retorno && retorno.Item?.Attributes) {
        setTextToast("Ordenação alterada com sucesso.");
        setShowToast(true);
        setListaConfiguracoesCupom(retorno.Item?.Attributes?.configuracoesCupom || []);
        dadosEmpresa.configuracoesCupom = retorno.Item?.Attributes?.configuracoesCupom;
        setDadosEmpresa(dadosEmpresa);

      }
      else {
        setTextToast("Ocorreu um erro ao ordernar.");
        setShowToast(true);
      }
    }

    ordItemConfiguracoesCupom();

  }


  const loadConfiguracoesCupom = () => {

    console.log();
    if (listaConfiguracoesCupom == undefined) return;

    if (listaConfiguracoesCupom.length === 0) {
      return (

        <IonItem lines="full" key={"semAgenda"}>

          <IonLabel>
            <h2 style={{ "verticalAlign": "middle" }}><strong>Nenhum cupom cadastrado</strong></h2>
          </IonLabel>

        </IonItem>


      );
    }




    return (
      <>
        <IonReorderGroup disabled={!podeOrdenar || showLoading} onIonItemReorder={handleReorder}>
          {listaConfiguracoesCupom.map((value: any, index: any) => {

            return (
              <IonItem lines="full" key={index}>
                {podeOrdenar && <IonReorder slot="start" className="list-reorder-handle" aria-label={`Ordenar ${value.nome || "item"}`}>
                  <IonIcon icon={reorderTwo} aria-hidden="true" />
                </IonReorder>}
                {/* <IonLabel style={{ fontSize: "12px", maxWidth: "60px" }}>
                <img id="imagem" style={{ objectFit: 'cover', width: "50px", height: "50px", borderRadius: '5px' }} src={value.urlImagem || imgDefaultImage}></img>
              </IonLabel> */}

                {/* <IonLabel style={{ fontSize: "12px" }}>{value.codigo}</IonLabel> */}
                <IonLabel style={{ fontSize: "12px" }}>{value.nome}</IonLabel>
                <IonLabel style={{ fontSize: "12px" }}>{(value.tipoDesconto || "fixo") === "percentual" ? `${value.valor}%` : `R$ ${value.valor}`}</IonLabel>
                <IonLabel style={{ fontSize: "12px" }}>{value.valorMinimo}</IonLabel>
                <IonLabel style={{ fontSize: "12px", maxWidth: "100px" }}>
                  {value.visivel === false ? (
                    <span title="Cupom oculto para o cliente" style={{ color: '#888', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                      <IonIcon icon={eyeOff} />
                    </span>
                  ) : null}
                </IonLabel>

                <div style={{ position: "absolute", right: "6px", zIndex: 9999999, backgroundColor: "#ffffff", textAlign: "right" }}>
                  <IonButtons>
                    <IonButton hidden={acessos?.configuracoes != 'edicao'}
                      onClick={() => {

                        setIndex(index);
                        setIdConfiguracaoEndereco(value.id);
                        setNome(value.nome);
                        // Compatibilidade: cupons antigos sem o campo são "fixo".
                        setTipoDesconto(value.tipoDesconto || "fixo");
                        setBaseDesconto(value.baseDesconto || "produtos");
                        setValor(value.valor);
                        setValorMinimo(value.valorMinimo);
                        // Compatibilidade: cupons antigos sem o campo são visíveis.
                        setVisivel(value.visivel !== false);




                        console.log("value", value);

                        setShowDetalhes(true);

                      }}>
                      <IonIcon color="primary" icon={pencil} />
                    </IonButton>


                    <IonButton hidden={acessos?.configuracoes != 'edicao'}
                      onClick={() => {
                        mostartAlerta({
                          backdropDismiss: false,
                          header: 'Remover item',
                          message: 'Deseja <strong>remover</strong>?',
                          buttons: [
                            {
                              text: 'Cancelar',
                              role: 'cancel',
                            },
                            {
                              text: 'Confirmar',
                              cssClass: 'primary',
                              handler: () => {
                                deletarConfiguracoesCupom(index);
                              }
                            }
                          ],
                          onDidDismiss: (e) => console.log('did dismiss'),
                        })
                      }}>
                      <IonIcon color="primary" icon={trash} />
                    </IonButton>

                  </IonButtons>


                </div>

              </IonItem>
            )
          })}
        </IonReorderGroup>
      </>
    );
  }


  const validate = () => {
    let isValid = true;
    let errors: Array<{ message: string }> = [];


    if (!nome) {
      isValid = false;
      errors.push({ message: `Nome não pode estar vazio.` });
    }

    if (!valor) {
      isValid = false;
      errors.push({ message: `Valor não pode estar vazio.` });
    }

    if (tipoDesconto === "percentual" && valor) {
      const pct = parseInt(String(valor).replace(/\D/g, ''), 10);
      if (isNaN(pct) || pct <= 0) {
        isValid = false;
        errors.push({ message: `A porcentagem deve ser maior que zero.` });
      } else if (pct > 100) {
        isValid = false;
        errors.push({ message: `A porcentagem não pode ser maior que 100%.` });
      }
    }

    if (!valorMinimo) {
      isValid = false;
      errors.push({ message: `Valor mínimo não pode estar vazio.` });
    }



    return { isValid, errors };
  };


  async function salvar() {

    const { isValid, errors } = validate();

    if (!isValid && errors.length > 0) {
      console.log('Erros de validação:', errors);

      // Mapeia o array de erros e retorna um array de strings para o IonToast
      const errorMessages: any = errors.map((error) => `${error.message}`);
      setTextToast(errorMessages.join('<br>'));
      setShowToast(true);
      return;
    }

    const objectRequest = {
      index: index,
      configuracoesCupom: {
        nome: nome,
        tipoDesconto: tipoDesconto,
        baseDesconto: baseDesconto,
        valor: valor,
        valorMinimo: valorMinimo,
        visivel: visivel,
      }
    }
    console.log("objectRequest", objectRequest);

    let id = loja;

    console.log("id", id);

    setShowLoading(true);

    await requestService(
      empresaConfiguracoesAlterar.url.replace("{id}", id.replaceAll("#", "%23")).concat("?configuracoescupom=sim"),
      {
        method: empresaConfiguracoesAlterar.method,
        body: JSON.stringify(objectRequest),
        headers: [
          ["token", window.localStorage.getItem("token")]
        ],
        credentials: 'include'
      },
      history,
      (response: any) => {
        console.log(response);
        if (response) {
          setTextToast("Cadastro realizado com sucesso.");
          setShowToast(true);

          console.log("response", response);

          setListaConfiguracoesCupom(response.message.Attributes.configuracoesCupom || []);
          dadosEmpresa.configuracoesCupom = response.message.Attributes.configuracoesCupom;
          setDadosEmpresa(dadosEmpresa);

          //carregarConta();
          setShowDetalhes(false);

        } else if (response.status === 400) {
          console.log(response);
          setTextToast("Ocorreu um erro ao efetuar o cadastro.");
          setShowToast(true);

        }
        setShowLoading(false);
      },
      (error: any) => {
        console.log(error);
        setTextToast("Ocorreu um erro ao efetuar o cadastro.");
        setShowToast(true);
        setShowLoading(false);
      })


  }

  const generateTimeOptions5Min = () => {
    const times = [];
    for (let minute = 10; minute <= 90; minute += 5) {
      const minuteStr = minute < 10 ? `0${minute}` : `${minute}`;
      times.push(`${minuteStr}`);
    }
    return times;
  };

  console.log(generateTimeOptions5Min());

  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    // Se for 0 horas, retorna apenas os minutos
    if (hours === 0 && mins > 0) {
      return `${mins} minutos`;
    }

    // Se for 0 minutos, retorna apenas as horas
    if (mins === 0 && hours > 0) {
      return `${hours} horas`;
    }

    // Se ambos forem diferentes de 0, retorna as horas e minutos
    return `${hours} horas e ${mins} minutos`;
  };

  const onChangeValor = (e: any) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");


    setValor(v);

  };

  // Percentual: apenas dígitos, sem máscara monetária, limitado a 100.
  const onChangeValorPercentual = (e: any) => {
    e.preventDefault();

    let v = e.target.value;
    v = v.replace(/\D/g, '');
    if (v !== '') {
      let n = parseInt(v, 10);
      if (n > 100) n = 100;
      v = String(n);
    }

    setValor(v);

  };

  const onChangeValorMinimo = (e: any) => {
    // e.persist();
    e.preventDefault();

    let v = e.target.value;

    v = v.replace(/\d{9}/, '');
    v = v.replace(/\D/g, '');
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2");
    v = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    v = v.replace(/^(\d)/g, "$1");


    setValorMinimo(v);

  };

  return (

    <IonPage className="Tipo">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Cupom</IonTitle>
        </IonToolbar>
        {isWeb && (
          <IonToolbar hidden={acessos?.configuracoes != 'edicao'}>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 8px 0 8px" }}>
              <IonButton
                fill="solid"
                size="large"
                color="tertiary"
                onClick={() => {
                setIndex("");
                setIdConfiguracaoEndereco("");
                setNome("");
                setTipoDesconto("fixo");
                setBaseDesconto("produtos");
                setValor("");
                setValorMinimo("");
                setVisivel(true);
                setShowDetalhes(true);
              }}
            >
                <IonIcon icon={add} slot="start" />
                Novo cupom
              </IonButton>
            </div>
          </IonToolbar>
        )}
        <IonToolbar>
          <IonList>
            <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
              {podeOrdenar && <span slot="start" className="list-reorder-spacer" aria-hidden="true" />}
              {/* <IonLabel style={{ fontSize: "12px", maxWidth: "60px" }}></IonLabel> */}
              <IonLabel style={{ fontSize: "12px" }}>Nome</IonLabel>
              <IonLabel style={{ fontSize: "12px" }}>Desconto</IonLabel>
              <IonLabel style={{ fontSize: "12px" }}>Valor Mínimo(R$)</IonLabel>

              <IonLabel style={{ textAlign: "right", maxWidth: "100px" }}></IonLabel>
            </IonItem>
          </IonList>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen={false}>
        {!isWeb && (
          <IonFab vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.configuracoes != 'edicao'}>
            <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => {
              setIndex("");
              setIdConfiguracaoEndereco("");

              setNome("");
              setTipoDesconto("fixo");
              setBaseDesconto("produtos");
              setValor("");
              setValorMinimo("");
              setVisivel(true);
              setShowDetalhes(true);
            }} >
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}

        <IonList>
          {loadConfiguracoesCupom()}

        </IonList>

        <IonModal onDidPresent={() => {
          if (inputRef.current) {
            inputRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => {
          setShowDetalhes(false);
          setIndex("");
          setIdConfiguracaoEndereco("");

          setNome("");
          setTipoDesconto("fixo");
          setBaseDesconto("produtos");
          setValor("");
          setValorMinimo("");
          setVisivel(true);
        }}>


          <>
            <IonHeader>
              <IonToolbar color="primary">
                <IonButtons slot="start">
                  <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowDetalhes(false)} />
                </IonButtons>
                <IonTitle>{index === "" ? "Novo cupom" : "Editar cupom"}</IonTitle>
              </IonToolbar>
            </IonHeader>
            <IonContent className="cupom-modal-content">
              <div className="cupom-form-container">
                <IonCard className="cupom-form-card">
                  <IonCardContent>
                    <div className="cupom-section-header">
                      <div className="cupom-section-icon cupom-section-icon--primary">
                        <IonIcon icon={ticketOutline} />
                      </div>
                      <div>
                        <div className="cupom-section-title">INFORMAÇÕES DO CUPOM</div>
                        <div className="cupom-section-subtitle">Identifique o cupom que será oferecido aos clientes</div>
                      </div>
                    </div>

                    <div className="cupom-field">
                      <label className="cupom-field-label">Nome*</label>
                      <IonInput
                        className="cupom-field-input"
                        placeholder="Digite o nome do cupom"
                        value={nome}
                        ref={(ref) => inputRef.current = ref}
                        autoCorrect='true'
                        autoCapitalize='true'
                        required
                        onIonInput={(e: any) => setNome(e.target.value)}
                      />
                    </div>
                  </IonCardContent>
                </IonCard>

                <IonCard className="cupom-form-card">
                  <IonCardContent>
                    <div className="cupom-section-header">
                      <div className="cupom-section-icon cupom-section-icon--success">
                        <IonIcon icon={cashOutline} />
                      </div>
                      <div>
                        <div className="cupom-section-title">REGRAS DO DESCONTO</div>
                        <div className="cupom-section-subtitle">Defina o tipo, o valor e as condições do benefício</div>
                      </div>
                    </div>

                    <div className="cupom-field">
                      <label className="cupom-field-label">Tipo de desconto*</label>
                      <IonRadioGroup
                        className="cupom-options-grid"
                        value={tipoDesconto}
                        onIonChange={(e: any) => {
                          setTipoDesconto(e.detail.value);
                          // Ao trocar o tipo, limpa o valor pois o formato muda (R$ x %).
                          setValor("");
                        }}
                      >
                        <IonItem className={`cupom-option-card${tipoDesconto === "fixo" ? " cupom-option-card--selected" : ""}`} lines="none">
                          <IonRadio slot="start" value="fixo" />
                          <IonLabel>
                            <strong>Valor fixo</strong>
                            <p>Desconto definido em reais</p>
                          </IonLabel>
                        </IonItem>
                        <IonItem className={`cupom-option-card${tipoDesconto === "percentual" ? " cupom-option-card--selected" : ""}`} lines="none">
                          <IonRadio slot="start" value="percentual" />
                          <IonLabel>
                            <strong>Porcentagem</strong>
                            <p>Percentual aplicado ao pedido</p>
                          </IonLabel>
                        </IonItem>
                      </IonRadioGroup>
                    </div>

                    <div className="cupom-fields-grid">
                      <div className="cupom-field">
                        <label className="cupom-field-label">
                          {tipoDesconto === "percentual" ? "Porcentagem do desconto*" : "Valor do desconto*"}
                        </label>
                        <IonInput
                          className="cupom-field-input"
                          clearInput={true}
                          type="tel"
                          maxlength={tipoDesconto === "percentual" ? 3 : 14}
                          placeholder={tipoDesconto === "percentual" ? "Ex.: 10" : "Valor do desconto"}
                          value={valor || ''}
                          onIonInput={tipoDesconto === "percentual" ? onChangeValorPercentual : undefined}
                          onIonChange={tipoDesconto === "fixo" ? onChangeValor : undefined}
                        />
                      </div>

                      <div className="cupom-field">
                        <label className="cupom-field-label">Valor mínimo do pedido*</label>
                        <IonInput
                          className="cupom-field-input"
                          clearInput={true}
                          type="tel"
                          maxlength={14}
                          placeholder="Valor mínimo para obter o desconto"
                          value={valorMinimo || ''}
                          onIonChange={(e: any) => onChangeValorMinimo(e)}
                        />
                      </div>
                    </div>

                    {tipoDesconto === "percentual" && (
                      <div className="cupom-field cupom-field--last">
                        <label className="cupom-field-label">Aplicar porcentagem sobre*</label>
                        <IonRadioGroup
                          className="cupom-options-grid"
                          value={baseDesconto}
                          onIonChange={(e: any) => setBaseDesconto(e.detail.value)}
                        >
                          <IonItem className={`cupom-option-card${baseDesconto === "produtos" ? " cupom-option-card--selected" : ""}`} lines="none">
                            <IonRadio slot="start" value="produtos" />
                            <IonLabel>
                              <strong>Produtos</strong>
                              <p>Somente o valor dos itens</p>
                            </IonLabel>
                          </IonItem>
                          <IonItem className={`cupom-option-card${baseDesconto === "total" ? " cupom-option-card--selected" : ""}`} lines="none">
                            <IonRadio slot="start" value="total" />
                            <IonLabel>
                              <strong>Total do pedido</strong>
                              <p>Produtos somados à taxa de entrega</p>
                            </IonLabel>
                          </IonItem>
                        </IonRadioGroup>

                        <div className="cupom-info-box">
                          <IonIcon icon={informationCircleOutline} />
                          <span>
                            “Produtos” considera apenas o valor dos itens. “Total do pedido” também inclui a taxa de entrega.
                          </span>
                        </div>
                      </div>
                    )}
                  </IonCardContent>
                </IonCard>

                <IonCard className="cupom-form-card">
                  <IonCardContent>
                    <div className="cupom-section-header">
                      <div className="cupom-section-icon cupom-section-icon--neutral">
                        <IonIcon icon={eyeOutline} />
                      </div>
                      <div>
                        <div className="cupom-section-title">VISIBILIDADE</div>
                        <div className="cupom-section-subtitle">Controle como o cupom aparece para os clientes</div>
                      </div>
                    </div>

                    <div className="cupom-toggle-row">
                      <div>
                        <div className="cupom-toggle-label">Exibir cupom para o cliente</div>
                        <div className="cupom-toggle-desc">
                          Quando oculto, o cupom não aparece em listagens, sugestões ou mensagens automáticas, mas continua válido quando digitado manualmente.
                        </div>
                      </div>
                      <IonToggle
                        checked={visivel}
                        onIonChange={(e: any) => setVisivel(e.detail.checked)}
                      />
                    </div>
                  </IonCardContent>
                </IonCard>
              </div>
            </IonContent>

            <IonFooter className="ion-no-border">
              <IonToolbar className="cupom-modal-footer">
                <IonButton onClick={() => salvar()} expand="block" type="submit">Salvar</IonButton>
              </IonToolbar>
            </IonFooter>
          </>

        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle" //top, bottom, middle
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />

      </IonContent>

    </IonPage >
  );


};

export default ConfiguracoesCupom;
